import React from 'react';
import DateToDateInput from '../../../../components/date-to-date-input/DateToDateInput';

export default (props) => {
    const {
        key,
        name,
        value,
        forcedValue,
        defaultValue,
        data,
        rules,
        options,
        disabled,
        ruleRequired,
        isRequired,
        onChange
    } = props;

    return <DateToDateInput
        value={forcedValue}
        defaultValue={defaultValue}
        disabled={disabled}
        getStartDateError={rules.custom && rules.custom[0] || undefined}
        getEndDateError={rules.custom && rules.custom[1] || undefined}
        minStartDate={rules.min && rules.min[0] || undefined}
        minEndDate={rules.min && rules.min[1] || undefined}
        maxStartDate={rules.max && rules.max[0] || undefined}
        maxEndDate={rules.max && rules.max[1] || undefined}
        shouldAllowInvalidDefaultStartDate={rules.shouldAllowInvalidDefaultValue && rules.shouldAllowInvalidDefaultValue[0] || false}
        shouldAllowInvalidDefaultEndDate={rules.shouldAllowInvalidDefaultValue && rules.shouldAllowInvalidDefaultValue[1] || false}
        startDateRemovable={!ruleRequired || !ruleRequired[0]}
        endDateRemovable={!ruleRequired || !ruleRequired[1]}
        onChange={onChange}
    />;
}
